<template>
  <div class="align-items-center justify-content-center introVideoPopup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="intro-video-view-wrapper justify-content-center">
          <div class="video">

            <div class="embed-responsive embed-responsive-16by9 video-preview" v-if="!videoLoaded && !videoStopped">
              <div class="replay-button">
                <div class="load-icon">
                  <LoadIcon :show="true"></LoadIcon>
                </div>
              </div>
            </div>

            <div class="embed-responsive embed-responsive-16by9 video-preview"
                 :class="videoLoaded && !videoStopped? '':'hide'">
              <div id="player"></div>
            </div>

            <div class="embed-responsive embed-responsive-16by9 video-preview" v-if="videoStopped">
              <div class="replay-button">
                <WhiteOutlineButton :buttonText="'Video opnieuw spelen'" :stretch-to-fill="false"
                                    v-on:clicked="replayVideoClicked"></WhiteOutlineButton>
              </div>
            </div>


            <div class="button-row">
              <WhiteOutlineButton :buttonText="'Volgende'" :stretch-to-fill="false"
                                  v-on:clicked="introVideoNextClicked"></WhiteOutlineButton>
            </div>
          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>
import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import LoadIcon from "@/components/StudentPlatform/LoadIcon";

export default {
  name: "IntroVideo",
  components: { WhiteOutlineButton, LoadIcon },
  props: {
    open: Boolean,
  },
  data()
  {
    return {
      show: false,
      videoLoaded: false,
      videoStopped: false,
      videoUrl: 'https://www.youtube.com/watch?v=Vbq_Mx-ied0',
      videoId: 'Vbq_Mx-ied0',
      player: null,
    }
  },
  computed: {},
  mixins: [],
  methods: {
    introVideoNextClicked()
    {
      this.$emit("introVideoNextClicked");
    },
    getScript(source, callback)
    {
      let script = document.createElement('script');
      let prior = document.getElementsByTagName('script')[0];
      script.async = true;

      script.onload = script.onreadystatechange = (_, isAbort) =>
      {
        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState))
        {
          script.onload = script.onreadystatechange = null;
          script = undefined;
          if (!isAbort) if (callback) callback();
        }
      };

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    },
    initYoutube()
    {
      let that = this;

      this.getScript("//www.youtube.com/iframe_api", function()
      {
        that.initPlayer();
      });
    },
    initPlayer()
    {

      let that = this;

      window.YT.ready(function()
      {
        that.player = new window.YT.Player('player', {
          height: '1080',
          width: '1920',
          videoId: that.videoId,
          playerVars: {
            'playsinline': 1
          },
          events: {
            'onReady': that.onPlayerReady,
            'onStateChange': that.onPlayerStateChange
          }
        });
      });

    },
    onPlayerReady()
    {
      this.videoLoaded = true;
    },
    onPlayerStateChange(evt)
    {
      if (evt.data === 0)
      {
        this.videoStopped = true;
      }
    },
    replayVideoClicked()
    {
      this.player.playVideo();
      this.videoStopped = false;
    }
  },
  mounted()
  {
    this.show = true;
    this.initYoutube();
  },
  created()
  {
  },
}


</script>

<style lang="scss" scoped>

.introVideoPopup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.video {
  width: 100%;
  height: 100%;
  position: relative;
}

.youtube {
  width: 100%;
  height: 100%;
  margin-bottom: 25px;
}

.intro-video-view-wrapper {
  display: flex;
  flex-direction: row;
  width: 80%;
  height: 60%;
}

.button-row {
  max-height: 50px;
  margin-top: 20px;
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.embed-responsive {
  height: 100%;
}

.replay-button {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.load-icon {
  width: 100px;
  height: 100px;
}

.hide {
  visibility: hidden;
  position: absolute;
}

</style>